module.exports = __webpack_public_path__ + "c7a263adaf5815db3bd243ed5940b591.png";